<template>
  <BreadCrumb PageTitle="Colis Connfirmées" />
  <ColisConfirmed />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ColisConfirmed from "@/components/Generals/Stores/ColisConfirmed.vue";

export default defineComponent({
  name: "ColisConfirmedPage",
  components: {
    BreadCrumb,
    ColisConfirmed,
  },
});
</script>